import React from 'react';

import {
    ReadyForFree,
    // Lacking,
    // Purchasing,
    Ready,
    Completed,
    Progressing,
    Quiz,
    Unsuccessful,
    // Passed,
    ComingSoon
} from 'constants/content-status';

import classes from './CourseProgress.module.scss';

const CourseProgress = ({ status }) => {
    return (
        <>
            {status != ComingSoon && (
                <div className={`${classes['first']} ${status === Completed ? classes['started'] : ''} `}>
                    <div className={`${classes['second']} ${(status === Quiz || status === Unsuccessful) ? classes['started'] : ''} ${status === Completed ? classes['finished'] : ''}`}>
                        <div className={`${classes['third']} ${(status === Progressing) ? classes['started'] : ''}  ${(status === Quiz || status === Unsuccessful || status === Completed) ? classes['finished'] : ''}`}>
                            Complete Modules
                        </div>
                        Take Quiz
                    </div>
                    Receive Certificate
                </div>
            )}
        </>
    );
};

export default CourseProgress;